import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { getAppraisalReportCsvData } from './reportDownloads/appraisalReport';
import { saveAs } from 'file-saver';
import {
  AGGREGATE_PERCENTAGE,
  PRACTICE_CHARACTERIZATION,
  UNIT_VS
} from '../../../constants/appraisal-report-types';
import JSZip from 'jszip';
import DownloadModalWithButton from '@shared/components/DownloadModalWithButton';

const availableReports = [
  { name: UNIT_VS, respectsPercentageVisibility: true },
  { name: PRACTICE_CHARACTERIZATION, respectsPercentageVisibility: false },
  { name: AGGREGATE_PERCENTAGE, respectsPercentageVisibility: true }
];

/**
 * @typedef {object} DownloadAppraisalReportModalProps
 * @property {Object} [data]
 * @property {boolean} [isPercentageVisible]
 * @property {boolean} [showPracticeCharacterizationForUnit]
 * @property {number} [selectedProgramYearValue]
 * @property {number} [selectedAppraisalId]
 */

/**
 * @param {DownloadAppraisalReportModalProps} props
 */
const DownloadAppraisalReportModal = props => {
  const {
    data,
    isPercentageVisible,
    showPracticeCharacterizationForUnit,
    selectedProgramYearValue,
    selectedAppraisalId
  } = props;

  const handleDownloadReports = async selectedReports => {
    const zip = new JSZip();

    const mddapOrgUnitInfo = get(data, 'appraisalComparisonOrgUnit', {});
    const appraisalOrgUnits = get(mddapOrgUnitInfo, 'AppraisalOrgUnits', []);

    const appraisalOrgUnit = appraisalOrgUnits.find(a => a.Appraisal.Id === selectedAppraisalId);
    const appraisalDate = moment(appraisalOrgUnit.Appraisal.ConductAppraisalEndDate).format('YYMM');

    const status = mddapOrgUnitInfo?.IsActive ? 'Enrolled' : 'De-Enrolled';
    const orgUnitName = mddapOrgUnitInfo?.Name;
    const fileName = `${appraisalDate}-appraisal-comparison-${orgUnitName}-${status}.csv`;
    const orgUnitId = mddapOrgUnitInfo?.Id;
    const reportData = await getAppraisalReportCsvData(
      appraisalOrgUnit,
      selectedProgramYearValue,
      orgUnitId,
      selectedReports,
      isPercentageVisible,
      showPracticeCharacterizationForUnit
    );

    zip.file(fileName, reportData);

    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, 'AppraisalComparison.zip');
    });
  };

  const reports = availableReports
    .filter(report => !report.respectsPercentageVisibility || isPercentageVisible)
    .map(report => ({
      title: report.name,
      disabled: false,
      value: report.name
    }));

  return <DownloadModalWithButton reports={reports} downloadReports={handleDownloadReports} />;
};

export default DownloadAppraisalReportModal;
